import { render, staticRenderFns } from "./videotask.vue?vue&type=template&id=3b77dc40&scoped=true"
import script from "./videotask.vue?vue&type=script&lang=js"
export * from "./videotask.vue?vue&type=script&lang=js"
import style0 from "./videotask.vue?vue&type=style&index=0&id=3b77dc40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b77dc40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b77dc40')) {
      api.createRecord('3b77dc40', component.options)
    } else {
      api.reload('3b77dc40', component.options)
    }
    module.hot.accept("./videotask.vue?vue&type=template&id=3b77dc40&scoped=true", function () {
      api.rerender('3b77dc40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/previewVideo/videotask.vue"
export default component.exports